import applogger from '@applogger'

const gqlDoc = `
  query info ($path: String!) {
    noitems: __type (name:"SomnambulistNoItems" ) {
      enumValues {
        name
        description
      }
    }
    frequency: __type (name:"SomnambulistFrequency" ) {
      enumValues {
        name
        description
      }
    }
    lookupcontentitem(path: $path) {
      ... on ContentInterface {
        id
      }
    }
  }
  query club ($id: ID!) {
    somnambulistclub(id: $id) {
      id
      status
      created
      featured
      customclub
      title
      abstract
      body
      image {
        data {
          alt
          title
        }
        filepath
        filestorename
      }
      selections {
        id
        title
        featured
        abstract
        body
        producttype
        frequency
        lastshippeddate
        nextshippeddate
        lockdate
        processingdate
        discountamt
        shippingcost
        noitems
        rrp
        productsettings {
          price
          sku
          taxfree
          discountgroup
        }
        products {
          product {
            id
            title
            abstract
            body
            award_winner
            rrp
            varietal
            wine_type
            sweetness
            unit_of_sale
            images {
              image {
                filepath
                filestorename
                preset
                data {
                  alt
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`

const cache = {
  loaded: false,
  id: null,
  noitems: [],
  frequencies: [],
  clubs: {}
}

const asyncLoader = function({ store, route, router }) {
  if (!route) {
    return Promise.resolve(false)
  }
  applogger.debug('wine-club asyncData starting')
  let gqlClient = store.getters['getGraphQLClient'](null, gqlDoc)
  return gqlClient.query({opName: 'info', variables: {path: route.path}})
    .then(response => {
      cache.loaded = true
      cache.id = response.data.lookupcontentitem.id
      cache.noitems = response.data.noitems.enumValues
      cache.frequencies = response.data.frequency.enumValues
      return gqlClient.query({opName: 'club', variables: {id: cache.id}})
    })
    .then(response => {
      cache.club = response.data.somnambulistclub
    })
    .then(() => {
      applogger.debug('wine-club asyncData Complete')
      return {
        itemid: cache.club.id,
        title: cache.club.title
      }
    })
    .catch(err => {
      applogger.error('An error occurred loading the page.')
      switch (err.response.status) {
      case 403:
        store.commit('SET_PAGE_SETTING', { key: 'error', value: 403 })
        break
      case 404:
        store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
        break
      default:
        store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
        break
      }
    })
}

const pageMixin = {
  created() {
    if (!cache.loaded || cache.clubs == null) {
      asyncLoader({store: this.$store})
    }
  },
  computed: {
    noitems() {
      return cache.noitems
    },
    frequencies() {
      return cache.frequencies
    },
    club() {
      return cache.club
    }
  }
}

export { pageMixin, asyncLoader }
